import { oddsKeyArray, oddsElement } from '../oddsKeyArray'

const initTwoSide = () => {
  const mainAndSup = {
    mainKey: 'two_side',
    supKey: 'total_sum'
  }
  let groupKey = ''

  return oddsKeyArray.reduce((root, oddsKey) => {
    groupKey = `ALL:SUM:${oddsKey}`
    root[groupKey] = {
      ...mainAndSup,
      groupKey
    }
    if (oddsKey === 'ODD' || oddsKey === 'EVEN') {
      root[`ALL:SUM:OVER:${oddsKey}`] = {
        ...mainAndSup,
        groupKey: `ALL:SUM:OVER:${oddsKey}`
      }
      root[`ALL:SUM:UNDER:${oddsKey}`] = {
        ...mainAndSup,
        groupKey: `ALL:SUM:UNDER:${oddsKey}`
      }
    }

    return root
  }, {})
}

const initAmountCompare = () => {
  const mainKey = 'amount_compare'
  const upDownPhase = {
    mainKey,
    supKey: 'up_down_phase'
  }
  const oddEvenPhase = {
    mainKey,
    supKey: 'odd_even_phase'
  }
  const upDown = ['UP', 'MID', 'DOWN']
  const oddsKeys = [...upDown, 'ODD', 'TIE', 'EVEN']
  let groupKey = ''
  let mainAndSup = {}

  return oddsKeys.reduce((root, oddsKey) => {
    switch (upDown.includes(oddsKey)) {
      case true:
        groupKey = `DIGIT:AMOUNT:${oddsKey}`
        mainAndSup = {
          ...upDownPhase,
          groupKey
        }
        break
      case false:
        groupKey = `PARITY:AMOUNT:${oddsKey}`
        mainAndSup = {
          ...oddEvenPhase,
          groupKey
        }
        break
    }

    root[groupKey] = {
      ...mainAndSup,
      groupKey
    }
    return root
  }, {})
}

const initElement = () => {
  return oddsElement.reduce((root, oddsKey) => {
    root[`SUM:${oddsKey}`] = {
      mainKey: 'element',
      supKey: oddsKey
    }

    return root
  }, {})
}

const initContain = () => {
  const mainKey = 'contain'
  const oddsKeyArray = ['one', 'two', 'three', 'four', 'five', 'six', 'seven']

  return oddsKeyArray.reduce((root, oddsKey, index) => {
    const numIndex = index + 1
    root[`CHOOSE:${numIndex}:MATCH:${numIndex}`] = {
      mainKey,
      supKey: `set_${oddsKey}_get_${oddsKey}`
    }

    return root
  }, {})
}

export default {
  ...initTwoSide(),
  ...initAmountCompare(),
  ...initElement(),
  ...initContain()
}
